/** Pul boshqaruvi (backend apps/finance, docs/12-moliya.md): hisoblar, kirim-chiqim, kurs, moliya paneli. */
import type { Money } from "@/features/budget/types";

export type Currency = "USD" | "UZS";
export type AccountKind = "cash" | "card" | "bank";
export const ACCOUNT_KINDS: AccountKind[] = ["cash", "card", "bank"];
export type Direction = "in" | "out";
export type TxKind = "fee" | "income" | "expense" | "salary" | "bonus" | "transfer" | "adjustment";

export interface MoneyAccount {
  id: number;
  name: string;
  kind: AccountKind;
  currency: Currency;
  bank: string;
  card_last4: string;
  branch: number | null;
  branch_name: string | null;
  opening_balance: Money;
  opening_date: string;
  note: string;
  balance: Money;
  has_transactions: boolean;
  is_archived: boolean;
  version: number;
}

export interface Transaction {
  id: number;
  account: number;
  account_name: string;
  date: string;
  direction: Direction;
  kind: TxKind;
  amount: Money;
  currency: Currency;
  rate: Money | null;
  amount_usd: Money | null;
  category: string;
  branch: number | null;
  branch_name: string | null;
  description: string;
  counterparty: string;
  expense: number | null;
  salary: number | null;
  bonus: number | null;
  application: number | null;
  driver_id: number | null;
  transfer_pair: number | null;
  transfer_account: string | null;
  created_by_name: string | null;
  created_at: string;
  is_archived: boolean;
  version: number;
  /** Bitta hisob bo'yicha ro'yxatda: shu yozuvdan keyingi qoldiq; aks holda null */
  balance_after: Money | null;
  /** Aniq vaqt (soniyagacha); o'tgan kunga vaqtsiz yozilgan bo'lsa null */
  at: string | null;
  /** Komissiya bo'lsa: `amount` -- net (hisobga ta'siri), asosiy summa va komissiya alohida; bo'lmasa null */
  base_amount: Money | null;
  commission_pct: Money | null;
  commission: Money | null;
}

export interface CategoryAmount {
  kind: TxKind;
  category: string;
  amount: Money;
}

export interface DueGroup {
  count: number;
  usd: Money;
}

export interface FinanceOverview {
  year: number;
  month: number;
  rate: { usd_uzs: Money | null; date: string | null; source: "cbu" | "manual" | null };
  accounts: { id: number; name: string; kind: AccountKind; currency: Currency; balance: Money; balance_usd: Money | null; branch: string | null }[];
  totals: { currency: Currency; balance: Money }[];
  total_usd: Money;
  month_in: Money;
  month_out: Money;
  month_net: Money;
  prev_in: Money;
  prev_out: Money;
  series: { period: string; in: Money; out: Money; net: Money }[];
  out_categories: CategoryAmount[];
  in_categories: CategoryAmount[];
  due: { expenses: DueGroup; salaries: DueGroup; bonuses: DueGroup; fees: DueGroup & { overdue: number; no_amount: number }; payable_usd: Money; receivable_usd: Money };
  missing_rate: boolean;
  tx_count: number;
  can_manage_accounts: boolean;
  can_direct_expense: boolean;
}

export interface Rate {
  date: string;
  usd_uzs: Money;
  source: "cbu" | "manual";
}

/** Xarajat/maosh/bonus qatoridagi to'lov: qaysi hisobdan */
export interface PaymentBrief {
  id: number;
  account: string;
  date: string;
  at?: string | null;
  amount: Money;
  currency: Currency;
  /** USD qiymati (kun kursi bilan) va izoh -- carrier to'lovi qoldig'i uchun */
  amount_usd?: string | null;
  description?: string;
  /** Komissiya bo'lsa: `amount` -- net, asosiy summa va komissiya alohida */
  base_amount?: Money | null;
  commission_pct?: Money | null;
  commission?: Money | null;
}
